// Starter lesson library — real, bilingual, age-appropriate content.
// Each lesson: slug, category, age, difficulty, minutes, title, desc, objectives[], sections[], check.
export const LESSONS = [
  {
    slug: "abc-adventure",
    category: "early-learning",
    age: "3-5",
    difficulty: "easy",
    minutes: 6,
    title: { en: "ABC Adventure", zh: "字母大冒险" },
    desc: { en: "Meet the letters A, B, and C and the sounds they make.", zh: "认识字母 A、B、C 以及它们的发音。" },
    objectives: {
      en: ["Recognize the letters A, B, and C", "Hear the sound each letter makes", "Find words that start with each letter"],
      zh: ["认识字母 A、B、C", "听出每个字母的发音", "找出以每个字母开头的单词"],
    },
    sections: [
      {
        title: { en: "Letter A is for Apple", zh: "A 代表 Apple（苹果）" },
        body: {
          en: "The letter A makes an 'ah' sound, like in Apple and Ant. Trace the shape of A in the air with your finger — it looks like a little tent!",
          zh: "字母 A 发 “啊” 的音，就像 Apple（苹果）和 Ant（蚂蚁）。用手指在空中描出 A 的形状——它看起来像一个小帐篷！",
        },
      },
      {
        title: { en: "B and C join the fun", zh: "B 和 C 一起加入" },
        body: {
          en: "B is for Ball and makes a 'buh' sound. C is for Cat and makes a 'kuh' sound. Say them out loud: A, B, C!",
          zh: "B 代表 Ball（球），发 “不” 的音。C 代表 Cat（猫），发 “克” 的音。大声念出来：A、B、C！",
        },
      },
    ],
    check: {
      q: { en: "Which word starts with the letter A?", zh: "哪个单词以字母 A 开头？" },
      options: { en: ["Ball", "Apple", "Cat"], zh: ["Ball（球）", "Apple（苹果）", "Cat（猫）"] },
      answer: 1,
    },
  },
  {
    slug: "counting-fun",
    category: "mathematics",
    age: "3-5",
    difficulty: "easy",
    minutes: 7,
    title: { en: "Counting Fun 1 to 10", zh: "快乐数数 1 到 10" },
    desc: { en: "Count from one to ten with friendly objects.", zh: "用可爱的物品从一数到十。" },
    objectives: {
      en: ["Count objects from 1 to 10", "Match numbers to groups", "Say the numbers in order"],
      zh: ["从 1 数到 10", "把数字和数量对应起来", "按顺序念出数字"],
    },
    sections: [
      {
        title: { en: "Let's count together", zh: "我们一起数" },
        body: {
          en: "One star, two stars, three stars! Each time we add one more, the number grows: 1, 2, 3, 4, 5. Keep going all the way to 10.",
          zh: "一颗星、两颗星、三颗星！每多一个，数字就变大：1、2、3、4、5。一直数到 10。",
        },
      },
      {
        title: { en: "Numbers have an order", zh: "数字是有顺序的" },
        body: {
          en: "Six comes after five. Seven comes after six. The order never changes — that's what makes counting so handy!",
          zh: "六在五的后面，七在六的后面。顺序永远不变——这正是数数如此好用的原因！",
        },
      },
    ],
    check: {
      q: { en: "What number comes right after 5?", zh: "5 后面紧接着是哪个数字？" },
      options: { en: ["4", "6", "10"], zh: ["4", "6", "10"] },
      answer: 1,
    },
  },
  {
    slug: "add-and-subtract",
    category: "mathematics",
    age: "6-8",
    difficulty: "medium",
    minutes: 9,
    title: { en: "Adding and Taking Away", zh: "加法与减法" },
    desc: { en: "Learn how addition and subtraction work with everyday examples.", zh: "通过日常例子学习加法和减法。" },
    objectives: {
      en: ["Understand what adding means", "Understand what subtracting means", "Solve simple one-step problems"],
      zh: ["理解加法的含义", "理解减法的含义", "解决简单的一步计算题"],
    },
    sections: [
      {
        title: { en: "Adding puts groups together", zh: "加法是把两组合在一起" },
        body: {
          en: "If you have 3 apples and a friend gives you 2 more, you add them: 3 + 2 = 5. Adding always makes the total bigger.",
          zh: "如果你有 3 个苹果，朋友又给你 2 个，就把它们相加：3 + 2 = 5。加法总会让总数变大。",
        },
      },
      {
        title: { en: "Subtracting takes some away", zh: "减法是拿走一些" },
        body: {
          en: "If you have 5 cookies and eat 2, you subtract: 5 − 2 = 3. Subtracting makes the total smaller.",
          zh: "如果你有 5 块饼干，吃掉 2 块，就做减法：5 − 2 = 3。减法会让总数变小。",
        },
      },
    ],
    check: {
      q: { en: "You have 4 balloons and 3 float away. How many are left?", zh: "你有 4 个气球，飞走了 3 个，还剩几个？" },
      options: { en: ["1", "7", "3"], zh: ["1", "7", "3"] },
      answer: 0,
    },
  },
  {
    slug: "animal-friends",
    category: "science",
    age: "6-8",
    difficulty: "easy",
    minutes: 8,
    title: { en: "Animal Friends & Their Homes", zh: "动物朋友和它们的家" },
    desc: { en: "Discover where different animals live and what they need.", zh: "了解不同动物住在哪里、需要什么。" },
    objectives: {
      en: ["Name a few animal habitats", "Explain what animals need to live", "Match an animal to its home"],
      zh: ["说出几种动物的栖息地", "说明动物生存需要什么", "把动物和它的家对应起来"],
    },
    sections: [
      {
        title: { en: "Every animal has a home", zh: "每种动物都有家" },
        body: {
          en: "A fish lives in water. A bird builds a nest in a tree. A rabbit digs a burrow underground. Their homes keep them safe.",
          zh: "鱼生活在水里，鸟在树上筑巢，兔子在地下挖洞。它们的家让它们保持安全。",
        },
      },
      {
        title: { en: "What animals need", zh: "动物需要什么" },
        body: {
          en: "Just like us, animals need food, water, shelter, and air. When we protect nature, we help animals have what they need.",
          zh: "和我们一样，动物需要食物、水、住所和空气。当我们保护大自然时，就是在帮助动物获得所需。",
        },
      },
    ],
    check: {
      q: { en: "Where does a fish live?", zh: "鱼住在哪里？" },
      options: { en: ["In a nest", "In the water", "In a burrow"], zh: ["在鸟巢里", "在水里", "在地洞里"] },
      answer: 1,
    },
  },
  {
    slug: "weather-wonders",
    category: "science",
    age: "6-8",
    difficulty: "medium",
    minutes: 8,
    title: { en: "Weather Wonders", zh: "奇妙的天气" },
    desc: { en: "Sun, rain, wind, and snow — learn what makes our weather.", zh: "太阳、雨、风和雪——了解天气是怎么形成的。" },
    objectives: {
      en: ["Name different kinds of weather", "Understand where rain comes from", "Dress for the weather"],
      zh: ["说出不同的天气类型", "理解雨是从哪里来的", "根据天气穿衣服"],
    },
    sections: [
      {
        title: { en: "The water cycle, simply", zh: "简单的水循环" },
        body: {
          en: "The sun warms water in oceans and lakes. The water rises as invisible vapor, cools into clouds, and falls back down as rain. Then it starts again!",
          zh: "太阳把海洋和湖泊里的水晒暖，水变成看不见的水汽升上天，冷却后变成云，再以雨的形式落下。然后循环重新开始！",
        },
      },
      {
        title: { en: "Reading the sky", zh: "读懂天空" },
        body: {
          en: "Grey clouds often mean rain is coming. A bright blue sky usually means a sunny day. Knowing the weather helps us plan.",
          zh: "灰色的云往往意味着要下雨，明亮的蓝天通常代表晴天。了解天气能帮我们做好计划。",
        },
      },
    ],
    check: {
      q: { en: "What usually happens to water after the sun warms it?", zh: "太阳晒暖水之后，水通常会怎样？" },
      options: { en: ["It disappears forever", "It rises and forms clouds", "It turns to stone"], zh: ["永远消失", "升上天形成云", "变成石头"] },
      answer: 1,
    },
  },
  {
    slug: "everyday-english",
    category: "languages",
    age: "6-8",
    difficulty: "easy",
    minutes: 7,
    title: { en: "Everyday English Greetings", zh: "日常英语问候" },
    desc: { en: "Learn friendly words to say hello, thank you, and goodbye.", zh: "学习打招呼、道谢和道别的友好用语。" },
    objectives: {
      en: ["Greet someone in English", "Say please and thank you", "Say goodbye politely"],
      zh: ["用英语向别人问好", "说 please 和 thank you", "礼貌地道别"],
    },
    sections: [
      {
        title: { en: "Saying hello", zh: "打招呼" },
        body: {
          en: "'Hello' and 'Hi' are friendly ways to greet someone. You can add 'How are you?' to show you care.",
          zh: "“Hello” 和 “Hi” 是友好的问候方式。你可以加上 “How are you?（你好吗？）” 来表示关心。",
        },
      },
      {
        title: { en: "Polite words", zh: "礼貌用语" },
        body: {
          en: "'Please' is for asking kindly. 'Thank you' shows you are grateful. 'Goodbye' or 'Bye' is how we leave.",
          zh: "“Please（请）” 用于礼貌地请求，“Thank you（谢谢）” 表示感激，“Goodbye” 或 “Bye” 是我们离开时说的话。",
        },
      },
    ],
    check: {
      q: { en: "Which word do you say to show you are grateful?", zh: "想表达感激时该说哪个词？" },
      options: { en: ["Hello", "Thank you", "Goodbye"], zh: ["Hello", "Thank you", "Goodbye"] },
      answer: 1,
    },
  },
  {
    slug: "online-safety",
    category: "digital",
    age: "9-12",
    difficulty: "medium",
    minutes: 10,
    title: { en: "Staying Safe Online", zh: "安全上网" },
    desc: { en: "Simple rules to protect yourself and your information online.", zh: "保护自己和个人信息的简单上网规则。" },
    objectives: {
      en: ["Keep personal information private", "Recognize when to ask an adult", "Be kind in online spaces"],
      zh: ["保护个人信息隐私", "知道何时应该询问大人", "在网络空间里保持友善"],
    },
    sections: [
      {
        title: { en: "Keep private things private", zh: "把隐私信息保护好" },
        body: {
          en: "Your full name, address, school, and passwords are private. Never share them with strangers online, and always ask a trusted adult if you're unsure.",
          zh: "你的全名、住址、学校和密码都是隐私。千万不要在网上告诉陌生人，不确定时一定要问信任的大人。",
        },
      },
      {
        title: { en: "Be kind and careful", zh: "友善又谨慎" },
        body: {
          en: "Treat people online the way you'd want to be treated. If something feels wrong or scary, tell an adult right away.",
          zh: "在网上对待别人，就像你希望别人怎样对待你。如果遇到让你感到不对或害怕的事，马上告诉大人。",
        },
      },
    ],
    check: {
      q: { en: "What should you do if a stranger online asks for your home address?", zh: "如果网上的陌生人问你家住址，你该怎么做？" },
      options: { en: ["Share it quickly", "Never share it and tell a trusted adult", "Share only your street"], zh: ["赶快告诉他", "绝不告诉，并报告信任的大人", "只说街道名"] },
      answer: 1,
    },
  },
  {
    slug: "saving-vs-spending",
    category: "financial",
    age: "9-12",
    difficulty: "medium",
    minutes: 9,
    title: { en: "Saving vs. Spending", zh: "储蓄与花费" },
    desc: { en: "Understand needs, wants, and why saving is smart.", zh: "理解需要、想要，以及储蓄为何明智。" },
    objectives: {
      en: ["Tell the difference between needs and wants", "Understand why people save", "Plan a tiny budget"],
      zh: ["区分 “需要” 和 “想要”", "理解人们为什么储蓄", "规划一个小小的预算"],
    },
    sections: [
      {
        title: { en: "Needs and wants", zh: "需要与想要" },
        body: {
          en: "A need is something you must have, like food and a safe home. A want is something nice to have, like a new toy. Both matter, but needs come first.",
          zh: "“需要” 是你必须拥有的，比如食物和安全的家；“想要” 是拥有了会很好的，比如新玩具。两者都重要，但需要要排在前面。",
        },
      },
      {
        title: { en: "Why saving helps", zh: "为什么储蓄有帮助" },
        body: {
          en: "When you save a little each week, it adds up. Saving lets you reach bigger goals later and be ready for surprises.",
          zh: "每周存一点，日积月累就会变多。储蓄让你以后能实现更大的目标，也能应对意外。",
        },
      },
    ],
    check: {
      q: { en: "Which of these is a 'need'?", zh: "下面哪一项是 “需要”？" },
      options: { en: ["A video game", "Healthy food", "A fancy watch"], zh: ["电子游戏", "健康的食物", "名贵手表"] },
      answer: 1,
    },
  },
  {
    slug: "what-is-blockchain",
    category: "financial",
    age: "9-12",
    difficulty: "hard",
    minutes: 10,
    title: { en: "What Is a Blockchain?", zh: "什么是区块链？" },
    desc: { en: "A gentle, age-appropriate intro to how a blockchain records information.", zh: "适龄、温和地介绍区块链如何记录信息。" },
    objectives: {
      en: ["Understand a blockchain as a shared notebook", "See why it's hard to change", "Connect it to transparency"],
      zh: ["把区块链理解为一本共享的笔记本", "明白它为何难以被更改", "把它和透明度联系起来"],
    },
    sections: [
      {
        title: { en: "A shared notebook", zh: "一本共享的笔记本" },
        body: {
          en: "Imagine a notebook that everyone in class can see. When someone writes a new line, everyone gets the same copy. A blockchain is a bit like that shared notebook on computers.",
          zh: "想象一本全班同学都能看到的笔记本。有人写下新的一行，大家都会得到相同的副本。区块链有点像电脑上的这本共享笔记本。",
        },
      },
      {
        title: { en: "Why it builds trust", zh: "它为什么能建立信任" },
        body: {
          en: "Because so many people hold the same copy, it's very hard to secretly change an old line. That's why blockchains can help make things like donations transparent and checkable.",
          zh: "因为许多人都持有相同的副本，想要偷偷改掉旧的一行就非常困难。这就是为什么区块链可以让捐助等事情变得透明、可核查。",
        },
      },
    ],
    check: {
      q: { en: "Why is it hard to secretly change a blockchain record?", zh: "为什么很难偷偷更改区块链上的记录？" },
      options: { en: ["Only one person keeps it", "Many people hold the same copy", "It is written in pencil"], zh: ["只有一个人保管它", "许多人都持有相同的副本", "它是用铅笔写的"] },
      answer: 1,
    },
  },
  {
    slug: "kindness-counts",
    category: "kindness",
    age: "6-8",
    difficulty: "easy",
    minutes: 6,
    title: { en: "Kindness Counts", zh: "善良很重要" },
    desc: { en: "Small acts of kindness and sharing make a big difference.", zh: "小小的善举和分享能带来大大的改变。" },
    objectives: {
      en: ["Understand empathy", "Find ways to share and help", "See how giving helps a community"],
      zh: ["理解同理心", "找到分享和帮助的方法", "明白奉献如何帮助社区"],
    },
    sections: [
      {
        title: { en: "Walking in someone's shoes", zh: "换位思考" },
        body: {
          en: "Empathy means imagining how someone else feels. If a friend is sad, a kind word or a shared snack can help them feel better.",
          zh: "同理心就是想象别人的感受。如果朋友难过，一句善意的话或分享一份零食，都能让他们好受一些。",
        },
      },
      {
        title: { en: "Giving helps everyone", zh: "奉献让大家都受益" },
        body: {
          en: "When we share what we have — time, help, or kindness — our whole community grows stronger and happier. That's the heart of LUMORA.",
          zh: "当我们分享自己拥有的——时间、帮助或善意——整个社区就会变得更强大、更快乐。这正是 LUMORA 的核心。",
        },
      },
    ],
    check: {
      q: { en: "What does empathy mean?", zh: "同理心是什么意思？" },
      options: { en: ["Imagining how others feel", "Winning a game", "Keeping everything for yourself"], zh: ["想象别人的感受", "赢得比赛", "把一切都留给自己"] },
      answer: 0,
    },
  },
];

export function getLesson(slug) {
  return LESSONS.find((l) => l.slug === slug);
}
export function lessonsByCategory(id) {
  return LESSONS.filter((l) => l.category === id);
}
